import React from 'react'

import { HeaderCell } from '../RACTable/HeaderCell'
import { AnalystCell, analystFilter, analystSort } from './AnalystCell'
import { DateCell, dateFilter } from './DateCell'
import { LanguageCell, languageFilter } from './LanguageCell'
import { RegionCell, regionFilter } from './RegionCell'
import { SectorCell, sectorFilter } from './SectorCell'
import { TitleCell, titleFilter } from './TitleCell'
import { sortColumnValues } from '../utils/sortColumnValues'
import { ColumnFilter } from '../ColumnFilter'

export type MarketingTag = {
  name: string
}

export const analystColumn = {
  accessor: 'analysts',
  Cell: ({ original }: any) => <AnalystCell analysts={original.analysts} />,
  filterMethod: ({ value }: any, { analysts }: any) =>
    analystFilter(value, analysts),
  Header: () => <HeaderCell heading="Analysts" />,
  Filter: ColumnFilter,
  id: 'analysts',
  sortMethod: analystSort
}

export const languageColumn = {
  accessor: 'language',
  Cell: (cellProps: any) => <LanguageCell cellProps={cellProps} />,
  filterMethod: languageFilter,
  Header: () => <HeaderCell heading="Language" />,
  id: 'language',
  Filter: ColumnFilter,
  sortMethod: (prev: MarketingTag, next: MarketingTag) => {
    const prevLang = prev.name
    const nextLang = next.name
    return sortColumnValues(prevLang, nextLang)
  }
}

export const publishedDateColumn = {
  accessor: 'publishedDate',
  Cell: (cellProps: any) => <DateCell cellProps={cellProps} />,
  filterMethod: dateFilter,
  Header: () => <HeaderCell heading="Published Date" />,
  id: 'publishedDate',
  Filter: ColumnFilter,
  sortMethod: (prev: any, next: any) =>
    new Date(prev).getTime() - new Date(next).getTime()
}

export const regionColumn = {
  accessor: 'regions',
  Cell: (cellProps: any) => <RegionCell cellProps={cellProps} />,
  filterMethod: regionFilter,
  Header: () => <HeaderCell heading="Regions" />,
  id: 'regions',
  Filter: ColumnFilter,
  sortMethod: (prev: MarketingTag[], next: MarketingTag[]) => {
    const prevRegion = prev[0].name
    const nextRegion = next[0].name
    return sortColumnValues(prevRegion, nextRegion)
  }
}

export const reportTypeColumn = {
  accessor: 'reportType',
  Filter: ColumnFilter,
  filterMethod: ({ value }: any, { reportType }: any) =>
    reportType && reportType.toLowerCase().includes(value.toLowerCase()),
  Header: () => <HeaderCell heading="Type" />
}

export const sectorColumn = {
  accessor: 'sectors',
  Cell: (cellProps: any) => <SectorCell cellProps={cellProps} />,
  filterMethod: sectorFilter,
  Header: () => <HeaderCell heading="Market Sectors" />,
  id: 'sectors',
  Filter: ColumnFilter,
  sortMethod: (prev: MarketingTag[], next: MarketingTag[]) => {
    const prevSector = prev[0].name
    const nextSector = next[0].name
    return sortColumnValues(prevSector, nextSector)
  }
}

export const titleColumn = {
  accessor: 'title',
  Cell: (cellProps: any) => <TitleCell cellProps={cellProps} />,
  filterMethod: titleFilter,
  Filter: ColumnFilter,
  Header: () => <HeaderCell heading="Title" />,
  id: 'title',
  sortMethod: (prev: string, next: string) => sortColumnValues(prev, next)
}
